import { Button } from "@ui/shad"

interface ZeroStateProps {
  title: string
  description: string
  onResetClick?: () => void
  resetText?: string
}

export default function ZeroState({
  title = "No results found",
  description,
  onResetClick,
  resetText = "Reset",
}: ZeroStateProps) {
  const hasReset = !!onResetClick
  return (
    <div className="flex w-full flex-col items-center justify-center gap-4 py-20">
      <div className="text-center">
        <p className="text-md font-medium">{title}</p>
        {!!description && <p className="text-muted-foreground text-sm">{description}</p>}
      </div>
      {hasReset && (
        <Button variant="outline" size="sm" onClick={onResetClick}>
          {resetText}
        </Button>
      )}
    </div>
  )
}
